import {RouterModule, Routes} from '@angular/router';

import {LocalizationComponent} from './localization.component';
import {CountiesComponent} from './components/counties/counties.component';
import {SectorsComponent} from './components/sectors/sectors.component';
import {SectorTypesComponent} from './components/sector-types/sector-types.component';
import {SectorCategoriesComponent} from './components/sector-categories/sector-categories.component';
import {SubCountiesComponent} from './components/sub-counties/sub-counties.component';
import {ConstituenciesComponent} from './components/constituencies/constituencies.component';
import {PopulationGroupComponent} from './components/population-group/population-group.component';
import {WardComponent} from "./components/wards/ward.component";

// noinspection TypeScriptValidateTypes
const routes: Routes = [
  {path: '', redirectTo: 'login', pathMatch: 'full'},
  {
    path: '',
    component: LocalizationComponent,
    children: [
      {path: 'counties', component: CountiesComponent},
      {path: 'sub-counties', component: SubCountiesComponent},
      {path: 'constituencies', component: ConstituenciesComponent},
      {path: 'sectors', component: SectorsComponent},
      {path: 'sector-types', component: SectorTypesComponent},
      {path: 'sector-categories', component: SectorCategoriesComponent},
      {path: 'population-group', component: PopulationGroupComponent},
      {path: 'wards', component: WardComponent}
    ]
  }
];

export const routing = RouterModule.forChild(routes);



// WEBPACK FOOTER //
// ./src/app/pages/localization/localization.routing.ts